export default __webpack_public_path__ + "static/image4-f9fc40db28c0bf5dbb1b592e93714a89.jpeg";